import React from 'react'

export default function LocationPage() {
  return (
    <div>LocationPage</div>
  )
}
